function makeMessageCardOverlay() {
  const selectors = [...document.querySelectorAll('[checked][data-option-value-id]')];
  if (selectors.length > 0) {
    const mediaDiv = document.querySelector('.product__media.media.media--transparent')
    const overlay = document.createElement('div');
    overlay.classList.add('message-card-overlay');
    overlay.id = `message-card-${selectors[0].value}`;
    const size = document.querySelector('[name="properties[文字サイズ]"]:checked')?.value ?? "中";
    overlay.dataset.messageCardFontSize=size;
    const title = document.createElement('div');
    title.classList.add('message-card-title');
    title.innerHTML = "";
    title.setAttribute('placeholder', "表題（未記入）");
    title.setAttribute('contenteditable', "plaintext-only");
    title.addEventListener('keypress', e=>{if(e.which === 13) e.preventDefault();});
    title.addEventListener('keyup', e=>{if (title.textContent.match(/^[ 　]*$/)) {title.innerHTML="";} document.querySelector('[name="properties[表題]"]').value=title.textContent;});
    const body = document.createElement('div');
    body.classList.add('message-card-body');
    body.innerHTML = "";
    body.setAttribute('contenteditable', "plaintext-only")
    body.setAttribute('placeholder', "本文（未記入）");
    body.addEventListener('keyup', e=>{if (body.textContent.match(/^[ 　]*$/)) {body.innerHTML="";} document.querySelector('[name="properties[本文]"]').value=body.textContent;});
    const name = document.createElement('div');
    name.classList.add('message-card-name');
    name.innerHTML = "";
    name.setAttribute('contenteditable', "plaintext-only");
    name.setAttribute('placeholder', "お名前など（未記入）");
    name.addEventListener('keypress', e=>{if(e.which === 13) e.preventDefault();});
    name.addEventListener('keyup', e=>{if (name.textContent.match(/^[ 　]*$/)) {name.innerHTML="";} document.querySelector('[name="properties[お名前など]"]').value=name.textContent;});
    overlay.append(title);
    overlay.append(body);
    overlay.append(name);
    mediaDiv.append(overlay);
  }
}

const observer = new MutationObserver((mutationsList, observer) => {
  let flag = false;
  mutationsList.forEach(mutation => {
    if (mutation.type === "childList") {
      mutation.addedNodes.forEach(n=>{
        if (n?.classList?.contains('product__media-item')) {
          makeMessageCardOverlay();
        } else if (n?.classList?.contains('bold_option_set')) {
          messagecardOptionArrenge(n);
        }
      });
    }
  });
});

function messagecardOptionArrenge(n) {
  n.querySelector('[name="properties[表題]"]')?.addEventListener('keyup', e => { 
    if (e.target.value.match(/^[ 　]*$/)) { e.target.value="";} 
    document.querySelector('.message-card-title').textContent = e.target.value;
  });
  n.querySelector('[name="properties[本文]"]')?.addEventListener('keyup', e => 
              document.querySelector('.message-card-body').innerHTML = e.target.value.replace(/\n/g, '<br>'));
  n.querySelector('[name="properties[お名前など]"]')?.addEventListener('keyup', e => { 
    if (e.target.value.match(/^[ 　]*$/)) { e.target.value="";} 
    document.querySelector('.message-card-name').textContent = e.target.value;
  });
  n.querySelector('input:has(+ [name="properties[中揃え]"])')?.addEventListener('change', e =>
              document.querySelector('.message-card-overlay').dataset.messageCardAlign=e.target.checked?"center":"");
  [...n.querySelectorAll('[name="properties[文字サイズ]"]')].forEach(r=>r.addEventListener('change', e =>
              document.querySelector('.message-card-overlay').dataset.messageCardFontSize=e.target.value));
}

messagecardOptionArrenge(document);
observer.observe(document.querySelector('.product'), { attributes: false, childList: true, subtree: true });

makeMessageCardOverlay();